    <h2>Supprimer l'encodage</h2>
    <p>Souhaitez-vous supprimer cet encodage ?</p>
    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()">Annuler</button>
        <button class="confirm" (click)="deleteRecord()">Confirmer</button>
    </div>
